<template>
  <rest
    :remote="remote"
    :table-columns="tableColumns"
    :formInitialize="formInitialize"
    :form-rules="formRules"
    :exportable="true"
    :export-visible="true"
    :create-able="true" :update-able="true" :delete-able="true"
    :use-drawer="true"
    drawer-width="50%"
  >
  </rest>
</template>

<script>

import Rest from '@/components/Spring/Rest'

export default {
  name: 'companies',
  components: { Rest },

  data () {
    return {
      remote: {
        path: 'channel',
        resource: this.$options.name,
        realtime: true,
        createLabel: '新增公司'
      },
      formInitialize: {},
      formRules: {
        id: [{ required: true, message: '请填写公司ID' }],
        name: [{ required: true, message: '请填写名称' }]
      }
    }
  },
  computed: {
    tableColumns () {
      return [
        { label: 'ID', prop: 'id', disabled: true, minWidth: 100 },
        { label: '名称', prop: 'name', minWidth: 220 },
        { label: '创建时间', prop: 'createdAt', type: 'datetime', hiddenForm: true, minWidth: 180 },
        { label: '修改时间', prop: 'updatedAt', type: 'datetime', hiddenForm: true, minWidth: 180 }
      ]
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style scoped>
</style>
